var _path, _path2, _path3, _path4, _mask, _path5, _path6, _mask2, _path7, _path8, _mask3, _path9, _path10, _mask4, _path11, _path12, _mask5, _path13, _path14, _mask6, _path15, _path16, _mask7, _path17, _path18, _mask8, _path19, _path20, _mask9, _path21, _path22, _mask10, _path23, _path24, _mask11, _path25, _path26, _mask12, _path27, _path28, _mask13, _path29, _path30, _mask14, _path31, _path32, _rect, _rect2, _mask15, _path33, _path34, _mask16, _path35, _path36, _mask17, _path37, _path38, _mask18, _path39, _path40, _mask19, _path41, _path42, _mask20, _path43, _path44, _mask21, _path45, _path46, _mask22, _path47, _path48, _mask23, _path49, _path50, _mask24, _path51, _path52, _mask25, _path53, _path54, _mask26, _path55, _path56, _mask27, _path57, _path58, _mask28, _path59, _path60, _path61, _mask29, _path62, _path63, _mask30, _path64, _path65, _mask31, _path66, _path67, _mask32, _path68, _path69, _path70, _mask33, _path71, _path72, _mask34, _path73, _path74, _mask35, _path75, _path76, _mask36, _path77, _path78, _path79, _mask37, _path80, _path81, _mask38, _path82, _path83, _mask39, _path84, _path85, _mask40, _path86, _path87, _path88, _mask41, _path89, _path90, _mask42, _path91, _path92, _mask43, _path93, _path94, _mask44, _path95, _path96, _path97, _mask45, _path98, _path99, _mask46, _path100, _path101, _mask47, _path102, _path103, _mask48, _path104, _path105, _path106, _mask49, _path107, _path108, _mask50, _path109, _path110, _mask51, _path111, _path112, _mask52, _path113, _path114, _rect3, _mask53, _path115, _path116, _mask54, _path117, _path118, _mask55, _path119, _path120, _mask56, _path121, _path122, _mask57, _path123, _path124, _mask58, _path125, _path126, _mask59, _path127, _path128, _mask60, _path129, _path130, _mask61, _path131, _path132, _mask62, _path133, _path134, _mask63, _path135, _path136, _mask64, _path137, _path138, _mask65, _path139, _path140, _mask66, _path141, _path142, _mask67, _path143, _path144, _mask68, _path145, _path146, _mask69, _path147, _path148, _mask70, _path149, _path150, _mask71, _path151, _path152, _mask72, _path153, _path154, _mask73, _path155, _path156, _mask74, _path157, _path158, _mask75, _path159, _path160, _rect4, _rect5, _rect6, _rect7, _mask76, _path161, _path162, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _rect8, _rect9, _rect10, _rect11, _line20, _line21, _line22, _line23, _rect12, _rect13, _rect14, _rect15, _line24, _line25, _line26, _line27, _rect16, _rect17, _rect18, _rect19, _line28, _line29, _line30, _line31, _rect20, _rect21, _rect22, _rect23, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _rect24, _mask77, _path171, _path172, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _line66, _line67, _rect25, _rect26, _rect27, _rect28, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircuit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 496,
    height: 314,
    viewBox: "0 0 496 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M321 131.5V172L288 187V276V279.5L256.5 297V313.5",
    stroke: "url(#paint0_linear_760_648)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M318 131.5V170.5L285.5 185.5V276V278.5L254 295.5V313.5",
    stroke: "url(#paint1_linear_760_648)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M315.5 127.5V168L282.5 183V276V277.5L251.5 294V313.5",
    stroke: "url(#paint2_linear_760_648)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M312.5 126.5V165.5L280 180.5V276L249.5 292.5V313.5",
    stroke: "url(#paint3_linear_760_648)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88 76H101V83H88V76Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88 76H101V83H88V76Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88 77H101V75H88V77Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-5-inside-1_760_648)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-2_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105 10H112V17H105V10Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105 10H112V17H105V10Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105 11H112V9H105V11Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-7-inside-2_760_648)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-3_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231 0H238V7H231V0Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M231 0H238V7H231V0Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M231 1H238V-1H231V1Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-9-inside-3_760_648)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-4_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240 0H247V7H240V0Z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M240 0H247V7H240V0Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M240 1H247V-1H240V1Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-11-inside-4_760_648)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-5_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249 0H256V7H249V0Z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M249 0H256V7H249V0Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M249 1H256V-1H249V1Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-13-inside-5_760_648)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-6_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258 0H265V7H258V0Z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M258 0H265V7H258V0Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M258 1H265V-1H258V1Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-15-inside-6_760_648)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-17-inside-7_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231 9H238V16H231V9Z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M231 9H238V16H231V9Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M231 10H238V8H231V10Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-17-inside-7_760_648)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-19-inside-8_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240 9H247V16H240V9Z"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M240 9H247V16H240V9Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M240 10H247V8H240V10Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-19-inside-8_760_648)"
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-21-inside-9_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249 9H256V16H249V9Z"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M249 9H256V16H249V9Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M249 10H256V8H249V10Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-21-inside-9_760_648)"
  })), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "path-23-inside-10_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246 74H253V81H246V74Z"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M246 74H253V81H246V74Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M246 75H253V73H246V75Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-23-inside-10_760_648)"
  })), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "path-25-inside-11_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258 9H265V16H258V9Z"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M258 9H265V16H258V9Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M258 10H265V8H258V10Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-25-inside-11_760_648)"
  })), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "path-27-inside-12_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369 9H376V16H369V9Z"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M369 9H376V16H369V9Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M369 10H376V8H369V10Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-27-inside-12_760_648)"
  })), _mask13 || (_mask13 = /*#__PURE__*/React.createElement("mask", {
    id: "path-29-inside-13_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378 9H385V16H378V9Z"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M378 9H385V16H378V9Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M378 10H385V8H378V10Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-29-inside-13_760_648)"
  })), _mask14 || (_mask14 = /*#__PURE__*/React.createElement("mask", {
    id: "path-31-inside-14_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396 9H403V16H396V9Z"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M396 9H403V16H396V9Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M396 10H403V8H396V10Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-31-inside-14_760_648)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 71,
    width: 3,
    height: 12,
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 71,
    width: 3,
    height: 12,
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _mask15 || (_mask15 = /*#__PURE__*/React.createElement("mask", {
    id: "path-35-inside-15_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95 167H97V177H95V167Z"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M95 167H97V177H95V167Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M95 168H97V166H95V168Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-35-inside-15_760_648)"
  })), _mask16 || (_mask16 = /*#__PURE__*/React.createElement("mask", {
    id: "path-37-inside-16_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99 167H101V177H99V167Z"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M99 167H101V177H99V167Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M99 168H101V166H99V168Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-37-inside-16_760_648)"
  })), _mask17 || (_mask17 = /*#__PURE__*/React.createElement("mask", {
    id: "path-39-inside-17_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103 167H105V177H103V167Z"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M103 167H105V177H103V167Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M103 168H105V166H103V168Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-39-inside-17_760_648)"
  })), _mask18 || (_mask18 = /*#__PURE__*/React.createElement("mask", {
    id: "path-41-inside-18_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101 157H105V161H101V157Z"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M101 157H105V161H101V157Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M101 158H105V156H101V158Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-41-inside-18_760_648)"
  })), _mask19 || (_mask19 = /*#__PURE__*/React.createElement("mask", {
    id: "path-43-inside-19_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107 157H111V161H107V157Z"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M107 157H111V161H107V157Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M107 158H111V156H107V158Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-43-inside-19_760_648)"
  })), _mask20 || (_mask20 = /*#__PURE__*/React.createElement("mask", {
    id: "path-45-inside-20_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131 185H135V189H131V185Z"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M131 185H135V189H131V185Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M131 186H135V184H131V186Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-45-inside-20_760_648)"
  })), _mask21 || (_mask21 = /*#__PURE__*/React.createElement("mask", {
    id: "path-47-inside-21_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137 185H141V189H137V185Z"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M137 185H141V189H137V185Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M137 186H141V184H137V186Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-47-inside-21_760_648)"
  })), _mask22 || (_mask22 = /*#__PURE__*/React.createElement("mask", {
    id: "path-49-inside-22_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113 157H117V161H113V157Z"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M113 157H117V161H113V157Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M113 158H117V156H113V158Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-49-inside-22_760_648)"
  })), _mask23 || (_mask23 = /*#__PURE__*/React.createElement("mask", {
    id: "path-51-inside-23_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132 157H136V161H132V157Z"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M132 157H136V161H132V157Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M132 158H136V156H132V158Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-51-inside-23_760_648)"
  })), _mask24 || (_mask24 = /*#__PURE__*/React.createElement("mask", {
    id: "path-53-inside-24_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239 193H257V211H239V193Z"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M239 193H257V211H239V193Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M239 194H257V192H239V194Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-53-inside-24_760_648)"
  })), _mask25 || (_mask25 = /*#__PURE__*/React.createElement("mask", {
    id: "path-55-inside-25_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239 218H242V221H239V218Z"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M239 218H242V221H239V218Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M239 219H242V217H239V219Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-55-inside-25_760_648)"
  })), _mask26 || (_mask26 = /*#__PURE__*/React.createElement("mask", {
    id: "path-57-inside-26_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253 218H256V221H253V218Z"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M253 218H256V221H253V218Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M253 219H256V217H253V219Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-57-inside-26_760_648)"
  })), _mask27 || (_mask27 = /*#__PURE__*/React.createElement("mask", {
    id: "path-59-inside-27_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225 241H231V243H225V241Z"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M225 241H231V243H225V241Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M225 242H231V240H225V242Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-59-inside-27_760_648)"
  })), _mask28 || (_mask28 = /*#__PURE__*/React.createElement("mask", {
    id: "path-61-inside-28_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225 233H231V235H225V233Z"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M225 233H231V235H225V233Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M225 234H231V232H225V234Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-61-inside-28_760_648)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M226.5 241L226.5 235L229.5 235L229.5 241L226.5 241Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _mask29 || (_mask29 = /*#__PURE__*/React.createElement("mask", {
    id: "path-64-inside-29_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229 239L229 237L230 237L230 239L229 239Z"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M229 239L229 237L230 237L230 239L229 239Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M230 239L230 237L228 237L228 239L230 239Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-64-inside-29_760_648)"
  })), _mask30 || (_mask30 = /*#__PURE__*/React.createElement("mask", {
    id: "path-66-inside-30_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226 239L226 237L227 237L227 239L226 239Z"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M226 239L226 237L227 237L227 239L226 239Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M227 239L227 237L225 237L225 239L227 239Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-66-inside-30_760_648)"
  })), _mask31 || (_mask31 = /*#__PURE__*/React.createElement("mask", {
    id: "path-68-inside-31_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233 241H239V243H233V241Z"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M233 241H239V243H233V241Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M233 242H239V240H233V242Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-68-inside-31_760_648)"
  })), _mask32 || (_mask32 = /*#__PURE__*/React.createElement("mask", {
    id: "path-70-inside-32_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233 233H239V235H233V233Z"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M233 233H239V235H233V233Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M233 234H239V232H233V234Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-70-inside-32_760_648)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M234.5 241L234.5 235L237.5 235L237.5 241L234.5 241Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _mask33 || (_mask33 = /*#__PURE__*/React.createElement("mask", {
    id: "path-73-inside-33_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237 239L237 237L238 237L238 239L237 239Z"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M237 239L237 237L238 237L238 239L237 239Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M238 239L238 237L236 237L236 239L238 239Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-73-inside-33_760_648)"
  })), _mask34 || (_mask34 = /*#__PURE__*/React.createElement("mask", {
    id: "path-75-inside-34_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234 239L234 237L235 237L235 239L234 239Z"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M234 239L234 237L235 237L235 239L234 239Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M235 239L235 237L233 237L233 239L235 239Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-75-inside-34_760_648)"
  })), _mask35 || (_mask35 = /*#__PURE__*/React.createElement("mask", {
    id: "path-77-inside-35_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241 241H247V243H241V241Z"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M241 241H247V243H241V241Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M241 242H247V240H241V242Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-77-inside-35_760_648)"
  })), _mask36 || (_mask36 = /*#__PURE__*/React.createElement("mask", {
    id: "path-79-inside-36_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241 233H247V235H241V233Z"
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M241 233H247V235H241V233Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M241 234H247V232H241V234Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-79-inside-36_760_648)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M242.5 241L242.5 235L245.5 235L245.5 241L242.5 241Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _mask37 || (_mask37 = /*#__PURE__*/React.createElement("mask", {
    id: "path-82-inside-37_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245 239L245 237L246 237L246 239L245 239Z"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M245 239L245 237L246 237L246 239L245 239Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M246 239L246 237L244 237L244 239L246 239Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-82-inside-37_760_648)"
  })), _mask38 || (_mask38 = /*#__PURE__*/React.createElement("mask", {
    id: "path-84-inside-38_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242 239L242 237L243 237L243 239L242 239Z"
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M242 239L242 237L243 237L243 239L242 239Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M243 239L243 237L241 237L241 239L243 239Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-84-inside-38_760_648)"
  })), _mask39 || (_mask39 = /*#__PURE__*/React.createElement("mask", {
    id: "path-86-inside-39_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249 241H255V243H249V241Z"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M249 241H255V243H249V241Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M249 242H255V240H249V242Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-86-inside-39_760_648)"
  })), _mask40 || (_mask40 = /*#__PURE__*/React.createElement("mask", {
    id: "path-88-inside-40_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249 233H255V235H249V233Z"
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M249 233H255V235H249V233Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M249 234H255V232H249V234Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-88-inside-40_760_648)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 241L250.5 235L253.5 235L253.5 241L250.5 241Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _mask41 || (_mask41 = /*#__PURE__*/React.createElement("mask", {
    id: "path-91-inside-41_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253 239L253 237L254 237L254 239L253 239Z"
  }))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M253 239L253 237L254 237L254 239L253 239Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M254 239L254 237L252 237L252 239L254 239Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-91-inside-41_760_648)"
  })), _mask42 || (_mask42 = /*#__PURE__*/React.createElement("mask", {
    id: "path-93-inside-42_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250 239L250 237L251 237L251 239L250 239Z"
  }))), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M250 239L250 237L251 237L251 239L250 239Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M251 239L251 237L249 237L249 239L251 239Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-93-inside-42_760_648)"
  })), _mask43 || (_mask43 = /*#__PURE__*/React.createElement("mask", {
    id: "path-95-inside-43_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257 241H263V243H257V241Z"
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M257 241H263V243H257V241Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M257 242H263V240H257V242Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-95-inside-43_760_648)"
  })), _mask44 || (_mask44 = /*#__PURE__*/React.createElement("mask", {
    id: "path-97-inside-44_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257 233H263V235H257V233Z"
  }))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M257 233H263V235H257V233Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M257 234H263V232H257V234Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-97-inside-44_760_648)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M258.5 241L258.5 235L261.5 235L261.5 241L258.5 241Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _mask45 || (_mask45 = /*#__PURE__*/React.createElement("mask", {
    id: "path-100-inside-45_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261 239L261 237L262 237L262 239L261 239Z"
  }))), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M261 239L261 237L262 237L262 239L261 239Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M262 239L262 237L260 237L260 239L262 239Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-100-inside-45_760_648)"
  })), _mask46 || (_mask46 = /*#__PURE__*/React.createElement("mask", {
    id: "path-102-inside-46_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258 239L258 237L259 237L259 239L258 239Z"
  }))), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M258 239L258 237L259 237L259 239L258 239Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M259 239L259 237L257 237L257 239L259 239Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-102-inside-46_760_648)"
  })), _mask47 || (_mask47 = /*#__PURE__*/React.createElement("mask", {
    id: "path-104-inside-47_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265 241H271V243H265V241Z"
  }))), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M265 241H271V243H265V241Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M265 242H271V240H265V242Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-104-inside-47_760_648)"
  })), _mask48 || (_mask48 = /*#__PURE__*/React.createElement("mask", {
    id: "path-106-inside-48_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265 233H271V235H265V233Z"
  }))), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M265 233H271V235H265V233Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M265 234H271V232H265V234Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-106-inside-48_760_648)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M266.5 241L266.5 235L269.5 235L269.5 241L266.5 241Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _mask49 || (_mask49 = /*#__PURE__*/React.createElement("mask", {
    id: "path-109-inside-49_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269 239L269 237L270 237L270 239L269 239Z"
  }))), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M269 239L269 237L270 237L270 239L269 239Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M270 239L270 237L268 237L268 239L270 239Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-109-inside-49_760_648)"
  })), _mask50 || (_mask50 = /*#__PURE__*/React.createElement("mask", {
    id: "path-111-inside-50_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266 239L266 237L267 237L267 239L266 239Z"
  }))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M266 239L266 237L267 237L267 239L266 239Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M267 239L267 237L265 237L265 239L267 239Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-111-inside-50_760_648)"
  })), _mask51 || (_mask51 = /*#__PURE__*/React.createElement("mask", {
    id: "path-113-inside-51_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239 178H242V181H239V178Z"
  }))), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M239 178H242V181H239V178Z",
    fill: "#BAD6F7",
    fillOpacity: 0.2
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M239 179H242V177H239V179Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-113-inside-51_760_648)"
  })), _mask52 || (_mask52 = /*#__PURE__*/React.createElement("mask", {
    id: "path-115-inside-52_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253 178H259V181H253V178Z"
  }))), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M253 178H259V181H253V178Z",
    fill: "#BAD6F7",
    fillOpacity: 0.2
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M253 179H259V177H253V179Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-115-inside-52_760_648)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 235.5,
    y: 189.5,
    width: 25,
    height: 25,
    stroke: "#BAD6F7",
    strokeOpacity: 0.1
  })), _mask53 || (_mask53 = /*#__PURE__*/React.createElement("mask", {
    id: "path-118-inside-53_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117 148H121V152H117V148Z"
  }))), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M117 148H121V152H117V148Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M117 149H121V147H117V149Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-118-inside-53_760_648)"
  })), _mask54 || (_mask54 = /*#__PURE__*/React.createElement("mask", {
    id: "path-120-inside-54_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125 142H129V146H125V142Z"
  }))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M125 142H129V146H125V142Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M125 143H129V141H125V143Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-120-inside-54_760_648)"
  })), _mask55 || (_mask55 = /*#__PURE__*/React.createElement("mask", {
    id: "path-122-inside-55_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107 167H109V177H107V167Z"
  }))), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M107 167H109V177H107V167Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M107 168H109V166H107V168Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-122-inside-55_760_648)"
  })), _mask56 || (_mask56 = /*#__PURE__*/React.createElement("mask", {
    id: "path-124-inside-56_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111 167H113V177H111V167Z"
  }))), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M111 167H113V177H111V167Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M111 168H113V166H111V168Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-124-inside-56_760_648)"
  })), _mask57 || (_mask57 = /*#__PURE__*/React.createElement("mask", {
    id: "path-126-inside-57_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115 167H117V177H115V167Z"
  }))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M115 167H117V177H115V167Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M115 168H117V166H115V168Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-126-inside-57_760_648)"
  })), _mask58 || (_mask58 = /*#__PURE__*/React.createElement("mask", {
    id: "path-128-inside-58_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119 167H121V177H119V167Z"
  }))), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M119 167H121V177H119V167Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M119 168H121V166H119V168Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-128-inside-58_760_648)"
  })), _mask59 || (_mask59 = /*#__PURE__*/React.createElement("mask", {
    id: "path-130-inside-59_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123 167H125V177H123V167Z"
  }))), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M123 167H125V177H123V167Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M123 168H125V166H123V168Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-130-inside-59_760_648)"
  })), _mask60 || (_mask60 = /*#__PURE__*/React.createElement("mask", {
    id: "path-132-inside-60_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127 167H129V177H127V167Z"
  }))), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M127 167H129V177H127V167Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M127 168H129V166H127V168Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-132-inside-60_760_648)"
  })), _mask61 || (_mask61 = /*#__PURE__*/React.createElement("mask", {
    id: "path-134-inside-61_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131 167H133V177H131V167Z"
  }))), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M131 167H133V177H131V167Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M131 168H133V166H131V168Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-134-inside-61_760_648)"
  })), _mask62 || (_mask62 = /*#__PURE__*/React.createElement("mask", {
    id: "path-136-inside-62_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135 167H137V177H135V167Z"
  }))), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M135 167H137V177H135V167Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M135 168H137V166H135V168Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-136-inside-62_760_648)"
  })), _mask63 || (_mask63 = /*#__PURE__*/React.createElement("mask", {
    id: "path-138-inside-63_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139 167H141V177H139V167Z"
  }))), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M139 167H141V177H139V167Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M139 168H141V166H139V168Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-138-inside-63_760_648)"
  })), _mask64 || (_mask64 = /*#__PURE__*/React.createElement("mask", {
    id: "path-140-inside-64_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225 257H227V267H225V257Z"
  }))), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M225 257H227V267H225V257Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M225 258H227V256H225V258Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-140-inside-64_760_648)"
  })), _mask65 || (_mask65 = /*#__PURE__*/React.createElement("mask", {
    id: "path-142-inside-65_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229 257H231V267H229V257Z"
  }))), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M229 257H231V267H229V257Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M229 258H231V256H229V258Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-142-inside-65_760_648)"
  })), _mask66 || (_mask66 = /*#__PURE__*/React.createElement("mask", {
    id: "path-144-inside-66_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233 257H235V267H233V257Z"
  }))), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M233 257H235V267H233V257Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M233 258H235V256H233V258Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-144-inside-66_760_648)"
  })), _mask67 || (_mask67 = /*#__PURE__*/React.createElement("mask", {
    id: "path-146-inside-67_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237 257H239V267H237V257Z"
  }))), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M237 257H239V267H237V257Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M237 258H239V256H237V258Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-146-inside-67_760_648)"
  })), _mask68 || (_mask68 = /*#__PURE__*/React.createElement("mask", {
    id: "path-148-inside-68_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241 257H243V267H241V257Z"
  }))), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M241 257H243V267H241V257Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M241 258H243V256H241V258Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-148-inside-68_760_648)"
  })), _mask69 || (_mask69 = /*#__PURE__*/React.createElement("mask", {
    id: "path-150-inside-69_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245 257H247V267H245V257Z"
  }))), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M245 257H247V267H245V257Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M245 258H247V256H245V258Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-150-inside-69_760_648)"
  })), _mask70 || (_mask70 = /*#__PURE__*/React.createElement("mask", {
    id: "path-152-inside-70_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249 257H251V267H249V257Z"
  }))), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M249 257H251V267H249V257Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M249 258H251V256H249V258Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-152-inside-70_760_648)"
  })), _mask71 || (_mask71 = /*#__PURE__*/React.createElement("mask", {
    id: "path-154-inside-71_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253 257H255V267H253V257Z"
  }))), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M253 257H255V267H253V257Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M253 258H255V256H253V258Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-154-inside-71_760_648)"
  })), _mask72 || (_mask72 = /*#__PURE__*/React.createElement("mask", {
    id: "path-156-inside-72_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257 257H259V267H257V257Z"
  }))), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M257 257H259V267H257V257Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M257 258H259V256H257V258Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-156-inside-72_760_648)"
  })), _mask73 || (_mask73 = /*#__PURE__*/React.createElement("mask", {
    id: "path-158-inside-73_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261 257H263V267H261V257Z"
  }))), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M261 257H263V267H261V257Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M261 258H263V256H261V258Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-158-inside-73_760_648)"
  })), _mask74 || (_mask74 = /*#__PURE__*/React.createElement("mask", {
    id: "path-160-inside-74_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265 257H267V267H265V257Z"
  }))), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M265 257H267V267H265V257Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M265 258H267V256H265V258Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-160-inside-74_760_648)"
  })), _mask75 || (_mask75 = /*#__PURE__*/React.createElement("mask", {
    id: "path-162-inside-75_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269 257H271V267H269V257Z"
  }))), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M269 257H271V267H269V257Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M269 258H271V256H269V258Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-162-inside-75_760_648)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 71,
    width: 3,
    height: 12,
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 381,
    y: 71,
    width: 3,
    height: 12,
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 71,
    width: 3,
    height: 12,
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 391,
    y: 71,
    width: 3,
    height: 12,
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _mask76 || (_mask76 = /*#__PURE__*/React.createElement("mask", {
    id: "path-168-inside-76_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111 76H131V83H111V76Z"
  }))), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M111 76H131V83H111V76Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M111 77H131V75H111V77Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-168-inside-76_760_648)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 49.5,
    x2: 80,
    y2: 49.5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.06
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 23.5,
    x2: 80,
    y2: 23.5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.06
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 30.5,
    x2: 80,
    y2: 30.5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.06
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 60.5,
    x2: 80,
    y2: 60.5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.06
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 67.5,
    x2: 80,
    y2: 67.5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.06
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 278,
    y1: 49.5,
    x2: 218,
    y2: 49.5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.06
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 278,
    y1: 23.5,
    x2: 218,
    y2: 23.5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.06
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 278,
    y1: 30.5,
    x2: 218,
    y2: 30.5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.06
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 278,
    y1: 60.5,
    x2: 218,
    y2: 60.5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.06
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 278,
    y1: 67.5,
    x2: 218,
    y2: 67.5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.06
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 416,
    y1: 49.5,
    x2: 356,
    y2: 49.5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.06
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 416,
    y1: 23.5,
    x2: 356,
    y2: 23.5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.06
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 416,
    y1: 30.5,
    x2: 356,
    y2: 30.5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.06
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 416,
    y1: 60.5,
    x2: 356,
    y2: 60.5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.06
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 416,
    y1: 67.5,
    x2: 356,
    y2: 67.5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.06
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 84.5,
    x2: 76,
    y2: 84.5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 7.5,
    x2: 76,
    y2: 7.50001,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 82,
    x2: 2.5,
    y2: 11,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 79.5,
    y1: 82,
    x2: 79.5,
    y2: 11,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 76.5,
    y: 5.5,
    width: 5,
    height: 5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 5.5,
    width: 5,
    height: 5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 82.5,
    width: 5,
    height: 5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 76.5,
    y: 82.5,
    width: 5,
    height: 5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 282,
    y1: 84.5,
    x2: 352,
    y2: 84.5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 282,
    y1: 7.5,
    x2: 352,
    y2: 7.50001,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 278.5,
    y1: 82,
    x2: 278.5,
    y2: 11,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 355.5,
    y1: 82,
    x2: 355.5,
    y2: 11,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 352.5,
    y: 5.5,
    width: 5,
    height: 5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 276.5,
    y: 5.5,
    width: 5,
    height: 5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 276.5,
    y: 82.5,
    width: 5,
    height: 5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 352.5,
    y: 82.5,
    width: 5,
    height: 5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 84.5,
    x2: 490,
    y2: 84.5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 7.5,
    x2: 490,
    y2: 7.50001,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 416.5,
    y1: 82,
    x2: 416.5,
    y2: 11,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 493.5,
    y1: 82,
    x2: 493.5,
    y2: 11,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 490.5,
    y: 5.5,
    width: 5,
    height: 5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 414.5,
    y: 5.5,
    width: 5,
    height: 5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 414.5,
    y: 82.5,
    width: 5,
    height: 5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 490.5,
    y: 82.5,
    width: 5,
    height: 5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 144,
    y1: 84.5,
    x2: 214,
    y2: 84.5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 144,
    y1: 7.5,
    x2: 214,
    y2: 7.50001,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 140.5,
    y1: 82,
    x2: 140.5,
    y2: 11,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 217.5,
    y1: 82,
    x2: 217.5,
    y2: 11,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 214.5,
    y: 5.5,
    width: 5,
    height: 5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 138.5,
    y: 5.5,
    width: 5,
    height: 5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 138.5,
    y: 82.5,
    width: 5,
    height: 5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 214.5,
    y: 82.5,
    width: 5,
    height: 5,
    stroke: "#BAD6F7",
    strokeOpacity: 0.08
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M458 134.5V175.5L299.5 235.5V276V283.5L266.5 303V313.5M454.5 134.5V173L296.5 233.5V276V282.5L264 301.5V313.5",
    stroke: "url(#paint4_linear_760_648)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M451 135L451 171.5L293.5 232V276.5V281.5L261.5 300V313.5M447 135V170L291 230V276.5V280.5L259 298.5V313.5",
    stroke: "url(#paint5_linear_760_648)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M175 131.5V172L208 187V276V279.5L239.5 297V313.5",
    stroke: "url(#paint6_linear_760_648)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M178 131.5V170.5L210.5 185.5V276V278.5L242 295.5V313.5",
    stroke: "url(#paint7_linear_760_648)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M180.5 127.5V168L213.5 183V276V277.5L244.5 294V313.5",
    stroke: "url(#paint8_linear_760_648)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M183.5 126.5V165.5L216 180.5V276L247 292.5V313.5",
    stroke: "url(#paint9_linear_760_648)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M38 134.5V175.5L196.5 235.5V276V283.5L229.5 303V313.5M41.5 134.5V173L199.5 233.5V276V282.5L232 301.5V313.5",
    stroke: "url(#paint10_linear_760_648)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M45 135L45 171.5L202.5 232V276.5V281.5L234.5 300V313.5M49 135V170L205 230V276.5V280.5L237 298.5V313.5",
    stroke: "url(#paint11_linear_760_648)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 349,
    y: 147,
    width: 32,
    height: 32,
    stroke: "#BAD6F7",
    strokeOpacity: 0.1,
    strokeWidth: 6
  })), _mask77 || (_mask77 = /*#__PURE__*/React.createElement("mask", {
    id: "path-226-inside-77_760_648",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356 154H374V172H356V154Z"
  }))), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M356 154H374V172H356V154Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M356 155H374V153H356V155Z",
    fill: "#BAD6F7",
    fillOpacity: 0.1,
    mask: "url(#path-226-inside-77_760_648)"
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 379,
    y1: 150.5,
    x2: 383,
    y2: 150.5,
    stroke: "#0B0815"
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 379,
    y1: 153.5,
    x2: 383,
    y2: 153.5,
    stroke: "#0B0815"
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 379,
    y1: 156.5,
    x2: 383,
    y2: 156.5,
    stroke: "#0B0815"
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 379,
    y1: 159.5,
    x2: 383,
    y2: 159.5,
    stroke: "#0B0815"
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 379,
    y1: 162.5,
    x2: 383,
    y2: 162.5,
    stroke: "#0B0815"
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 379,
    y1: 165.5,
    x2: 383,
    y2: 165.5,
    stroke: "#0B0815"
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 379,
    y1: 168.5,
    x2: 383,
    y2: 168.5,
    stroke: "#0B0815"
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 379,
    y1: 171.5,
    x2: 383,
    y2: 171.5,
    stroke: "#0B0815"
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 379,
    y1: 174.5,
    x2: 383,
    y2: 174.5,
    stroke: "#0B0815"
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 347,
    y1: 150.5,
    x2: 351,
    y2: 150.5,
    stroke: "#0B0815"
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 347,
    y1: 153.5,
    x2: 351,
    y2: 153.5,
    stroke: "#0B0815"
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 347,
    y1: 156.5,
    x2: 351,
    y2: 156.5,
    stroke: "#0B0815"
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 347,
    y1: 159.5,
    x2: 351,
    y2: 159.5,
    stroke: "#0B0815"
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 347,
    y1: 162.5,
    x2: 351,
    y2: 162.5,
    stroke: "#0B0815"
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 347,
    y1: 165.5,
    x2: 351,
    y2: 165.5,
    stroke: "#0B0815"
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 347,
    y1: 168.5,
    x2: 351,
    y2: 168.5,
    stroke: "#0B0815"
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 347,
    y1: 171.5,
    x2: 351,
    y2: 171.5,
    stroke: "#0B0815"
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 347,
    y1: 174.5,
    x2: 351,
    y2: 174.5,
    stroke: "#0B0815"
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 377.5,
    y1: 145,
    x2: 377.5,
    y2: 149,
    stroke: "#0B0815"
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 374.5,
    y1: 145,
    x2: 374.5,
    y2: 149,
    stroke: "#0B0815"
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    x1: 371.5,
    y1: 145,
    x2: 371.5,
    y2: 149,
    stroke: "#0B0815"
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    x1: 368.5,
    y1: 145,
    x2: 368.5,
    y2: 149,
    stroke: "#0B0815"
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    x1: 365.5,
    y1: 145,
    x2: 365.5,
    y2: 149,
    stroke: "#0B0815"
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    x1: 362.5,
    y1: 145,
    x2: 362.5,
    y2: 149,
    stroke: "#0B0815"
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    x1: 359.5,
    y1: 145,
    x2: 359.5,
    y2: 149,
    stroke: "#0B0815"
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    x1: 356.5,
    y1: 145,
    x2: 356.5,
    y2: 149,
    stroke: "#0B0815"
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    x1: 353.5,
    y1: 145,
    x2: 353.5,
    y2: 149,
    stroke: "#0B0815"
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    x1: 377.5,
    y1: 177,
    x2: 377.5,
    y2: 181,
    stroke: "#0B0815"
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    x1: 374.5,
    y1: 177,
    x2: 374.5,
    y2: 181,
    stroke: "#0B0815"
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    x1: 371.5,
    y1: 177,
    x2: 371.5,
    y2: 181,
    stroke: "#0B0815"
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    x1: 368.5,
    y1: 177,
    x2: 368.5,
    y2: 181,
    stroke: "#0B0815"
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    x1: 365.5,
    y1: 177,
    x2: 365.5,
    y2: 181,
    stroke: "#0B0815"
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    x1: 362.5,
    y1: 177,
    x2: 362.5,
    y2: 181,
    stroke: "#0B0815"
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    x1: 359.5,
    y1: 177,
    x2: 359.5,
    y2: 181,
    stroke: "#0B0815"
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    x1: 356.5,
    y1: 177,
    x2: 356.5,
    y2: 181,
    stroke: "#0B0815"
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    x1: 353.5,
    y1: 177,
    x2: 353.5,
    y2: 181,
    stroke: "#0B0815"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 146,
    width: 2,
    height: 2,
    fill: "#0B0815"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 348,
    y: 146,
    width: 2,
    height: 2,
    fill: "#0B0815"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 178,
    width: 2,
    height: 2,
    fill: "#0B0815"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 348,
    y: 178,
    width: 2,
    height: 2,
    fill: "#0B0815"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_760_648",
    x1: 285.731,
    y1: 309,
    x2: 285.731,
    y2: 131.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAD6F7",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_760_648",
    x1: 282.731,
    y1: 309,
    x2: 282.731,
    y2: 131.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAD6F7",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_760_648",
    x1: 280.231,
    y1: 305,
    x2: 280.231,
    y2: 127.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAD6F7",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_760_648",
    x1: 277.231,
    y1: 304,
    x2: 277.231,
    y2: 126.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAD6F7",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_760_648",
    x1: 298,
    y1: 309,
    x2: 298,
    y2: 135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAD6F7",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_760_648",
    x1: 280,
    y1: 309,
    x2: 280,
    y2: 135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAD6F7",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_760_648",
    x1: 210.269,
    y1: 309,
    x2: 210.269,
    y2: 131.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAD6F7",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_760_648",
    x1: 213.269,
    y1: 309,
    x2: 213.269,
    y2: 131.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAD6F7",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_760_648",
    x1: 215.769,
    y1: 305,
    x2: 215.769,
    y2: 127.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAD6F7",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_760_648",
    x1: 218.769,
    y1: 304,
    x2: 218.769,
    y2: 126.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAD6F7",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_760_648",
    x1: 198,
    y1: 309,
    x2: 198,
    y2: 135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAD6F7",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_760_648",
    x1: 216,
    y1: 309,
    x2: 216,
    y2: 135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAD6F7",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircuit);
export default __webpack_public_path__ + "static/media/circuit.f7b283cc1ae77344de91ac5dc2f78485.svg";
export { ForwardRef as ReactComponent };